<template>
    <div class="courseList">
        <div class="nav">
            <ul class="typeBar">
                <li :class="{ active: courseType == 1 }" @click="chooseType(1)">关节</li>
                <li :class="{ active: courseType == 2 }" @click="chooseType(2)">创伤</li>
                <li :class="{ active: courseType == 3 }" @click="chooseType(3)">脊柱</li>
                <li :class="{ active: courseType == 5 }" @click="chooseType(5)">菁英</li>
                <li :class="{ active: courseType == 11 }" @click="chooseType(11)">直播回放</li>
            </ul>
        </div>
        <DataList v-if="courseList.length" :dataArray="courseList" @transfer="toDetail" />
        <div v-if="noData">
            <div class="noData flexColum">
                <img src="@/assets/img/none.png" alt="" />
                <p>暂无内容</p>
            </div>
        </div>
        <div class="pageBar" v-if="courseList.length">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="pageNum"
                :page-size="20"
                :total="totcalCount"
                @current-change="changePageNum"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import DataList from "../Common/DataList";

export default {
    name: "CourseList",
    data() {
        return {
            courseList: [],
            courseType: 1,
            pageNum: 1,
            totcalCount: 0,
            userId: localStorage.getItem("userId") || "",
            noData:false,
        };
    },

    components: { DataList },
    mounted() {
        this.getCourseData(1, 1);
        this.addDataBuried(1);
    },
    methods: {
        getCourseData(videoType, pageNum) {
            this.$loading({
                background: "rgba(0, 0, 0, 0.7)",
                text: "拼命加载中"
            });
            let params = {
                category: 1,
                charge: 1,
                keyword: "",
                pageNum: pageNum,
                rank: "updateTime",
                type: videoType
            };
            this.$axios
                .post("/web/course/queryTypeCourseList", this.$qs.stringify(params))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        this.courseList = data.result_data.courseList;
                        this.totcalCount = data.result_data.totalCount;
                        this.noData = data.result_data.courseList.length == 0
                    } else {
                        this.$message.error(data.message);
                    }
                    this.$loading().close();
                })
                .catch(err => {
                    this.$loading().close();
                });
        },
        chooseType(type) {
            this.courseType = type;
            this.pageNum = 1;
            this.getCourseData(type, 1);
            this.addDataBuried(type);
        },
        changePageNum(val) {
            this.pageNum = val;
            this.getCourseData(this.courseType, val);
        },
        toDetail(dic) {
            this.$router.push({ path: "/classVideo", params: { gid: dic.gid }, query: { gid: dic.gid }});

        },
        addDataBuried(type) {
            let typeArr = ["关节", "创伤", "脊柱", "菁英", "直播回放"];

            let headers = {
                equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                phoneModel: "", //手机型号
                appVersionNumber: "" //app版本号
            };
            this.$axios
                .post(
                    "/SD/statistic/addDataBuried",
                    this.$qs.stringify({
                        usergid: this.userId,
                        moduleType: "14",
                        subModuleType: typeArr[type - 1],
                        locationType: "1",
                        disMobile: "PC"
                    }),
                    {
                        headers
                    }
                )
                .then(res => {});
        }
    }
};
</script>

<style scoped src="../../assets/css/ul-list.css"></style>
<style scoped lang="less">
.noData {
    display: flex;
    padding: 100px 0;
    img {
        width: 300px;
    }
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active{
    background-color: #5680FA;
}
.el-pagination.is-background /deep/ .el-pager li:hover{
    color: #5680FA;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active:hover{
    color: #ffffff;
}
</style>
